import { render, staticRenderFns } from "./Selfsufficiency.vue?vue&type=template&id=24267403&scoped=true&"
import script from "./Selfsufficiency.vue?vue&type=script&lang=js&"
export * from "./Selfsufficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24267403",
  null
  
)

export default component.exports